// Slice the array, but truncate index at zero to prevent wrapping around
function truncatingSlice(array: Array<number>, startIndex: number, endIndex: number): Array<number> {
  if (startIndex < 0) {
    return array.slice(0, endIndex);
  }
  return array.slice(startIndex, endIndex);
}

// Return the array of the moving averages of an array of values.
export default function movingAverage(array: Array<number>, slidingWindowSize: number): Array<number> {
  return array.map((unused: number, index: number) => {
    const startIndex = index - Math.floor(slidingWindowSize / 2);
    const slice = truncatingSlice(array, startIndex, startIndex + slidingWindowSize);
    return slice.reduce((accumulator: number, value: number) => accumulator + value, 0) / slice.length;
  });
}
